var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRise = function SvgRise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.1rem",
    height: "0.8rem",
    viewBox: "0 0 21.818 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m21.582.003-5.251.638a.214.214 0 0 0-.172.144.218.218 0 0 0 .048.22l1.563 1.526-5.949 6.033-2.687-2.72a.424.424 0 0 0-.596 0L.059 14.426a.23.23 0 0 0 0 .308l1.192 1.206a.21.21 0 0 0 .292 0l7.298-7.377 2.677 2.71a.435.435 0 0 0 .596 0l7.152-7.24 1.563 1.582a.212.212 0 0 0 .217.049.216.216 0 0 0 .142-.174l.63-5.317a.2.2 0 0 0-.236-.17z"
  })));
};
export default SvgRise;